// Gladly Chat SDK Implementation
!function(c,n,r,t){if(!c[r]){var i,d,p=[];d="PROD"!==t&&t?"STAGING"===t?"https://cdn.gladly.qa/gladly/chat-sdk/widget.js":t:"https://cdn.gladly.com/chat-sdk/widget.js",c[r]={init:function(){i=arguments;var e={then:function(t){return p.push({type:"t",next:t}),e},catch:function(t){return p.push({type:"c",next:t}),e}};return e}},c.__onHelpAppHostReady__=function(t){if(delete c.__onHelpAppHostReady__,(c[r]=t).loaderCdn=d,i)for(var e=t.init.apply(t,i),n=0;n<p.length;n++){var a=p[n];e="t"===a.type?e.then(a.next):e.catch(a.next)}},function(){try{var t=n.getElementsByTagName("script")[0],e=n.createElement("script");e.async=!0,e.src=d+"?q="+(new Date).getTime(),t.parentNode.insertBefore(e,t)}catch(t){}}()}}
(window,document,'Gladly','PROD')

// Gladly Chat Configuration
window.gladlyConfig = {
  appId: 'hermsprengerusa.com'
};

// Z-Index Fix mit MutationObserver
(function() {
  function forceZIndex() {
    const container = document.querySelector('#gladlyChat_container');
    if (container) {
      container.style.setProperty('z-index', '1', 'important');
    }
  }

  // Beobachte Änderungen am Container
  const observer = new MutationObserver(forceZIndex);

  // Warte bis Container existiert
  const checkInterval = setInterval(() => {
    const container = document.querySelector('#gladlyChat_container');
    if (container) {
      clearInterval(checkInterval);
      forceZIndex();

      // Beobachte style-Änderungen
      observer.observe(container, {
        attributes: true,
        attributeFilter: ['style', 'class']
      });
    }
  }, 100);

  // Cleanup nach 10 Sekunden
  setTimeout(() => clearInterval(checkInterval), 10000);
})();